import EBarAdminHome from './EBarAdminHome';

export default EBarAdminHome;
